// extracted by mini-css-extract-plugin
export default {"SurfacePapier":"SurfacePapier_SurfacePapier__W+HN0"};